import mammoth from "mammoth";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import TermsFrenchAlt from "../assets/ARIVU_ASF_TermsofUse_and_Services fr.docx";
import TermsEnglishAlt from "../assets/ARIVU_ASF_TermsofUse_and_Services.docx";
import TermsFrench from "../assets/ARIVU_RUMKER_TermsofUse_and_Services FR.docx";
import TermsEnglish from "../assets/ARIVU_RUMKER_TermsofUse_and_Services.docx";
import { useAuth } from "../authentication/AuthProvider";
import { usePendingUser } from "../authentication/PendingUserContext";
import { useContextProvider } from "../components/page-context/ContextProvider";
import config from "../config";
import "../style/pages-style/TermsAndConditions.css";

const TermsAndConditions = () => {
  const { selectedLanguage } = useContextProvider();
  const navigate = useNavigate();
  const auth = useAuth();
  const { t } = useTranslation();
  const { pendingUser, setPendingUser, setTermsAccepted } = usePendingUser();
  const [docxContent, setDocxContent] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [storedUsername, setStoredUsername] = useState(localStorage.getItem("username"));

  const currentVersion = config.version;

  useEffect(() => {
    const loadDocx = async () => {
      try {
        const selectedFile = storedUsername === "Rumker" ? (selectedLanguage === "en" ? TermsEnglish : TermsFrench) : selectedLanguage === "en" ? TermsEnglishAlt : TermsFrenchAlt;
        const response = await fetch(selectedFile);
        const arrayBuffer = await response.arrayBuffer();
        const { value } = await mammoth.extractRawText({ arrayBuffer });
        setDocxContent(value);
      } catch (error) {
        setErrorMessage(t("Failed to load terms and conditions."));
      }
    };

    loadDocx();
  }, [selectedLanguage, storedUsername, t]); // Added dependency on storedUsername

  // Listen for changes in localStorage
  useEffect(() => {
    const handleStorageChange = () => {
      setStoredUsername(localStorage.getItem("username"));
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  const handleAccept = () => {
    if (!isChecked) {
      setErrorMessage(t("You must accept the terms and conditions before proceeding."));
      return;
    }
    if (pendingUser) {
      auth.login(pendingUser);
      setPendingUser(null);
      setTermsAccepted(true);
      localStorage.setItem("termsAccepted", "true");
    }

    if (currentVersion === "abc") {
      navigate("/home");
      return;
    }
    navigate("/homeviewtype");
  };

  const handleDecline = () => {
    setPendingUser(null);
    auth.logout();
    setTermsAccepted(false);
    localStorage.setItem("termsAccepted", "false");
    navigate("/");
  };

  return (
    <div className="terms-container">
      <h1 className="terms-header">{t("Terms and Conditions")}</h1>
      <div className="terms-content">
        {docxContent ? (
          <div
            dangerouslySetInnerHTML={{
              __html: docxContent.replace(/\n/g, "<br>"),
            }}
          />
        ) : (
          <p>{t("Loading terms and conditions...")}</p>
        )}
      </div>
      <div className="checkbox-container">
        <label>
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => {
              setIsChecked(e.target.checked);
              setErrorMessage("");
            }}
          />
          {t("I have read and accept the terms and conditions.")}
        </label>
      </div>
      {errorMessage && <p className="error-message">{errorMessage}</p>}
      <div className="terms-buttons">
        <button onClick={handleAccept} className="button-login">
          {t("Accept")}
        </button>{" "}
        <button onClick={handleDecline} className="button-logout">
          {t("Decline")}
        </button>
      </div>
    </div>
  );
};

export default TermsAndConditions;
